import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { DateRange } from './types/filters'

// Extend dayjs with plugins
dayjs.extend(isBetween)
dayjs.extend(customParseFormat)
dayjs.extend(utc)
dayjs.extend(timezone)

export const isWithinDateRange = (date: string, range: DateRange): boolean => {
  if (!range.start || !range.end) return true;
  return dayjs(date).isBetween(range.start, range.end, 'day', '[]');
};

export const formatDate = (date: dayjs.Dayjs | null): string => {
  return date ? date.format('YYYY-MM-DD') : '';
};

export default dayjs
